<template>
<div class="animated fadeIn">
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col lg="12">
          <!--<h6>Simple Form</h6>-->
          <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>

            <b-form-group label="Name" label-for="name">
              <b-form-input id="name" type="text" aria-describedby="liveFeedbackname" v-model.lazy.trim="$v.form.name.$model" placeholder="Name" autofocus />
              <b-form-invalid-feedback id="liveFeedbackname" :state="chkState('name')">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Email" label-for="email">
              <b-form-input id="email" type="text" aria-describedby="liveFeedbackEmail" :state="chkState('email')" v-model.lazy.trim="$v.form.email.$model" placeholder="Email" />
              <b-form-invalid-feedback id="liveFeedbackEmail">
                This is a required field
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Password" label-for="password">
              <b-form-input id="password" type="text" aria-describedby="liveFeedbackPassword" :state="chkState('password')" v-model.lazy.trim="$v.form.password.$model" placeholder="Password" />
              <b-form-invalid-feedback id="liveFeedbackPassword">
                This is a required field
              </b-form-invalid-feedback>
            </b-form-group>

            <b-button type="submit" variant="primary" :disabled="$v.form.$invalid">
              Submit
            </b-button>
            <b-button class="ml-1" type="reset" @click="onCancel">Cancel</b-button>
          </b-form>
          <br />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</div>
</template>

<script>
import Vue from 'vue'
import {
  mapState,
  mapActions
} from 'vuex'
import {
  required,
  email
} from "vuelidate/lib/validators"

const formShape = {
  name: "",
  email: "",
  password: ""
}

export default {
  name: "UserFormAdd",
  data() {
    return {
      form: Object.assign({}, formShape),
      submitted: false
    }
  },
  computed: {
    isValid() {
      return !this.$v.form.$anyError
    },
    isDirty() {
      return this.$v.form.$anyDirty
    },
  },
  validations: {
    form: {
      name: {
        required
      },
      email: {
        required,
        email
      },
      password: {
        required
      }
    }
  },
  methods: {
    onSubmit() {
      if (this.validate()) {
        this.$nextTick(() => {
          this.submitted = true
          let params = {
            name: this.$v.form.name.$model,
            email: this.$v.form.email.$model,
            password: this.$v.form.password.$model,
          }

          Vue.axios.post('/admin/users', params).then((response) => {
            this.$emit('success')
            this.showSuccessMsg()
          }).catch((error) => {
            if (error.response.status == 422) {
              this.showErrorMsg({
                message: this.getResponseErrorMessage(error.response.data)
              })
            } else {
              this.showErrorMsg()
            }
          })

        })
      }
    },
    onCancel() {
      this.$emit('cancel')
    },
    onReset() {
      // Reset validation
      this.form = formShape
      this.submitted = false
      this.$nextTick(() => {
        this.$v.$reset()
      })
    },
    chkState(val) {
      const field = this.$v.form[val]
      return field.$dirty ? !field.$invalid : null
    },
    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate() {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    }
  },
  created() {}
}
</script>
